export function Spinner({ size = 18, className = "" }: { size?: number; className?: string }) {
  return (
    <span
      className={"inline-block animate-spin rounded-full border-2 border-line border-t-brand1 " + className}
      style={{ width: size, height: size }}
      role="status"
      aria-label="Loading"
    />
  );
}

/** Full-page loading fallback for lazy routes. */
export function PageSpinner({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="flex items-center justify-center gap-3 p-16 text-sm text-text3">
      <Spinner />
      {label}
    </div>
  );
}
